'use strict';

angular.module('mobile-apps').controller('CustomFilterModalController', [
	'$scope',
	'ModalInputData',
	'$modalInstance',
	'EntryMain',
	'Utilities',
	'TeamData',
	'SweetAlert',
	'EntryStatus',
	'Teams',
	function (
		$scope,
		ModalInputData,
		$modalInstance,
		EntryMain,
		Utilities,
		TeamData,
		SweetAlert,
		EntryStatus,
		Teams
	) {

		$scope.EntryMain = EntryMain;

		$scope.filter = {
			key: '',
			active: undefined,
			saved: {}
		};

		$scope.errorMessage = undefined;
		$scope.filterKeyInputError = false;

		$scope.datePickersOpen = {
			creationDateTo: false,
			creationDateFrom: false,
			changeDateTo: false,
			changeDateFrom: false
		};
		$scope.users = [];
		$scope.statusValues = [];

		$scope.filterValues = {};

		// The default start values for status and user
		var anyStatus = {
			id: 'any',
			name: 'Any'
		};
		var anyUser = {
			id: 'any',
			displayName: 'Any'
		};
		var anyMetadata = {
			id: 0,
			fieldName: 'Any',
			order: 0
		};

		//Metadata
		$scope.metadata = [];
		$scope.metadataFilterOperators = [
			'Contains',
			'Does not contain',
			'Equals',
			'Does not equal',
			'Has any value',
			'Has no value'
		];

		/**
		 * Selects a filter as active and updates the filter values accordingly
		 * @param filterKey
		 */
		$scope.filterSelect = function(filterKey) {
			if (!$scope.filter.saved.hasOwnProperty(filterKey)) {
				Utilities.showMessage(
					'Problem!',
					'There is no filter named: ' + filterKey,
					'error'
				);
				return;
			}


			// First reset the filter because only not empty values get saved
			// in the database
			$scope.resetFilter();

			$scope.filter.key = filterKey;
			$scope.filter.active = filterKey;

			// Set the saved custom filter
			var filterData = $scope.filter.saved[filterKey];
			$scope.setFilterValues(filterData);
		};


		/**
		 * Returns how many filters are saved
		 * @returns {Number}
		 */
		$scope.numSavedFilters = function() {
			return Object.keys($scope.filter.saved).length;
		};


		/**
		 * Saves the currently set filter values as new custom filter
		 */
		$scope.filterSave = function() {

			if (!$scope.filter.key || $scope.filter.key.length === 0) {
				$scope.errorMessage = 'Filter name is required';
				$scope.filterKeyInputError = true;
				return;
			}
			$scope.filterKeyInputError = false;

			// Load the filters
			TeamData.set({
				teamId: $scope.mobileApp.team._id,
				category: 'filters',
				key: $scope.filter.key,
				data: $scope.getFilterValues()
			}, function (filter) {
				$scope.filter.active = $scope.filter.key;
				$scope.filter.saved = filter.result;

				$scope.errorMessage = undefined;

				Utilities.showMessage(
					'Saved!',
					'The filter "' + $scope.filter.key + '" got saved!',
					'success'
				);
			}, function (err) {
				// Filter could not be saved
				$scope.errorMessage = 'There was a problem saving the filter!';
				console.log(err);
			});
		};


		/**
		 * Deletes the currently active filter
		 */
		$scope.filterDelete = function() {
			if (!$scope.filter.active) {
				$scope.errorMessage = 'There is currently not filter active that can be deleted';
				return;
			}

			// Let the user confirm if he really wants to delete the filter
			SweetAlert.swal(
				{
					title             : 'Are you sure?',
					text              : 'This will delete the filter "' + $scope.filter.active + '" which can not be undone.',
					type              : 'info',
					showCancelButton  : true,
					confirmButtonColor: '#DD6B55',
					confirmButtonText : 'Yes, delete!',
					cancelButtonText  : 'No, cancel!',
					closeOnConfirm    : true,
					closeOnCancel     : true
				},
				function (isConfirm) {
					if (isConfirm) {

						// Load the filters
						TeamData.remove({
							teamId: $scope.mobileApp.team._id,
							category: 'filters',
							key: $scope.filter.active
						}, function (result) {
							var deleteKeyName = $scope.filter.active;

							// Filter got deleted so reset the current filter data
							$scope.resetFilter();

							if (result.result) {
								// The user has still other filters saved
								$scope.filter.saved = result.result;
							} else {
								// User does not have any more filters
								$scope.filter.saved = {};
							}

							$scope.errorMessage = undefined;

							Utilities.showMessage(
								'Deleted!',
								'The filter "' + deleteKeyName + '" got deleted!',
								'success'
							);

						}, function (err) {
							// Filter could not be saved
							$scope.errorMessage = 'There was a problem deleting the filter!';
							console.log(err);
						});

					}
				}
			);

		};


		/**
		 * Initializes all values
		 */
		$scope.init = function() {
			if (ModalInputData.emptyFilter !== true) {
				$scope.filterValues = ModalInputData.previousFilters;
				// If a filter is already active set it as such also in the modal
				if (ModalInputData.activeFilterKey) {
					$scope.filter.key = ModalInputData.activeFilterKey;
					$scope.filter.active = ModalInputData.activeFilterKey;
				}
			}

			// Init status
			$scope.statusValues.push(anyStatus);
			$scope.statusValues.push({
				id: 'none',
				name: 'None'
			});
			for (var id in EntryStatus.statusInformation) {
				var statusInfo = EntryStatus.statusInformation[id];
				$scope.statusValues.push({
					id: id,
					name: statusInfo.name
				});
			}
			if (!$scope.filterValues.hasOwnProperty('status')) {
				$scope.filterValues.status = anyStatus;
			}

			// Init users
			if (!$scope.filterValues.hasOwnProperty('lastUserChanged')) {
				$scope.filterValues.lastUserChanged = anyUser;
			}
			$scope.users.push(anyUser);

			// Query the team-members and system-users
			EntryMain._fetchMobileApp(ModalInputData.appId, false, function(err, mobileApp) {
				// Add system users
				if (mobileApp.hasOwnProperty('_systemUsers') && angular.isArray(mobileApp._systemUsers)) {
					mobileApp._systemUsers.forEach(function(systemUser) {
						$scope.users.push({
							id: systemUser._id,
							displayName: systemUser.displayName
						});
					});
				}

				$scope.mobileApp = mobileApp;

				// Load the team members
				Teams.get({
						teamId: $scope.mobileApp.team._id
					},
					function success (response) {
						response.members.forEach(function(member) {
							$scope.users.push({
								id: member.user._id,
								displayName: member.user.displayName
							});
						});
					}, function failure (errResponse) {
						console.log(errResponse);
					});


				// Load the filters
				TeamData.get({
					teamId: $scope.mobileApp.team._id,
					category: 'filters'
				}, function (filter) {
					$scope.filter.saved = filter.result;
				}, function (err) {
					// Filters could not be loaded
					$scope.errorMessage = 'There was a problem loading the filter!';
					console.log(err);
				});

				//Init metadata filter
				if(mobileApp.metadata && mobileApp.metadata.length){
					$scope.metadata.push(anyMetadata);
					$scope.metadata = $scope.metadata.concat(mobileApp.metadata);
					
					if (!$scope.filterValues.hasOwnProperty('metadata')) {
						$scope.filterValues.metadata = {operator: $scope.metadataFilterOperators[0], key: $scope.metadata[0], value: null };
					}
				}
			});
		};


		/**
		 * Whenever a value of a checkbox changed it makes sure that other
		 * checkboxes that are in conflict with the current one are not set.
		 * @param key The key of the checkbox that changed
		 */
		$scope.checkboxChanged = function(key) {
			if (EntryMain.filterValues.checkboxes.hasOwnProperty(key)) {
				var checkboxData = EntryMain.filterValues.checkboxes[key];
				if ($scope.filterValues[key] === true && checkboxData.hasOwnProperty('notActive')) {
					checkboxData.notActive.forEach(function(keyNotActive) {
						$scope.filterValues[keyNotActive] = false;
					});
				}
			}
		};


		/**
		 * Returns all the currently active filters as one object
		 * @returns {{}}
		 */
		$scope.getFilterValues = function () {
			var filterValues = {};

			filterValues.status = $scope.filterValues.status;
			filterValues.lastUserChanged = $scope.filterValues.lastUserChanged;
			filterValues.metadata = $scope.filterValues.metadata;

			EntryMain.filterValues.dateFilters.forEach(function(dateFilter) {
				if ($scope.filterValues[dateFilter.from]) {
					filterValues[dateFilter.from] = $scope.filterValues[dateFilter.from];
				}
				if ($scope.filterValues[dateFilter.to]) {
					filterValues[dateFilter.to] = $scope.filterValues[dateFilter.to];
				}
			});

			Object.keys(EntryMain.filterValues.checkboxes).forEach(function(key) {
				if ($scope.filterValues[key] === true) {
					filterValues[key] = $scope.filterValues[key];
				}
			});

			return filterValues;
		};


		/**
		 * Sets all filters according to the given object
		 * @returns {{}}
		 */
		$scope.setFilterValues = function (filterValues) {
			Object.keys(filterValues).forEach(function(key) {
				$scope.filterValues[key] = filterValues[key];
			});
		};


		/**
		 * Reset all the filters
		 */
		$scope.resetFilter = function (resetActiveFilter) {

			// Deselect any active filter
			$scope.filter.key = '';
			$scope.filter.active = undefined;

			// Reset all values
			$scope.filterValues.status = anyStatus;
			$scope.filterValues.lastUserChanged = anyUser;

			$scope.filterValues.metadata = {operator: $scope.metadataFilterOperators[0], key: $scope.metadata[0], value: null };

			EntryMain.filterValues.dateFilters.forEach(function(dateFilter) {
				$scope.filterValues[dateFilter.from] = null;
				$scope.filterValues[dateFilter.to] = null;
			});

			Object.keys(EntryMain.filterValues.checkboxes).forEach(function(key) {
				$scope.filterValues[key] = false;
			});
		};


		/**
		 * Applies the filter
		 */
		$scope.applyFilter = function () {
			var activeKey;

			if ($scope.filter.active) {
				// Check if the current filter settings are still identical
				// to the currently active filter. Only then do we also
				// display the filter as active in the list
				var filterData = $scope.filter.saved[$scope.filter.active];
				var currentData = JSON.parse(JSON.stringify($scope.getFilterValues()));
				if (angular.equals(filterData, currentData)) {
					activeKey = $scope.filter.active;
				}
			}

			$modalInstance.close({
				filterValues: $scope.filterValues,
				activeFilterKey: activeKey
			});
		};


		/**
		 * Opens the datepicker with the given name
		 * @param datePickerName The datepicker to open
         */
		$scope.openDatePicker = function(datePickerName, event) {
			$scope.datePickersOpen[datePickerName] = true;
		};


		$scope.init();
	}
]);
